import {FormattedMessage} from "react-intl";
import React from "react";

import "./ParlayCancelled.style.scss";
const ParlayCancelled = ({ parlay, showReason }) => {

    return <div className="ParlayCancelled">
            <p><FormattedMessage id={"preSelectedParlayBanner.cancelled"}/></p>
            {(parlay.CancellationReason && showReason) && <p>{parlay.CancellationReason}</p>}
        </div>;

};

export default ParlayCancelled;